import Vue from 'vue'
import Router from 'vue-router'

import index from '../pages/index'
import acceleration from '../pages/acceleration'
import amountofsubtance from '../pages/amount-of-subtance'
import angle from '../pages/angle'
import area from '../pages/area'
import astronomical from '../pages/astronomical'
import bloodsugar from '../pages/blood-sugar'
import capacitance from '../pages/capacitance'
import computer from '../pages/computer'
import cooking from '../pages/cooking'
import datatransfer from '../pages/data-transfer'
import density from '../pages/density'
import dynamicviscosity from '../pages/dynamic-viscosity'
import electriccharge from '../pages/electric-charge'
import electricalresistance from '../pages/electrical-resistance'
import energy from '../pages/energy'
import force from '../pages/force'
import illuminance from '../pages/illuminance'
import inductance from '../pages/inductance'
import length from '../pages/length'
import temperature from '../pages/temperature'
import volume from '../pages/volume'
import weight from '../pages/weight'
import time from '../pages/time'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: index
    },
    {
      path: '/acceleration',
      component: acceleration
    },
    {
      path: '/amount-of-substance',
      component: amountofsubtance
    },
    {
      path: '/angle',
      component: angle
    },
    {
      path: '/area',
      component: area
    },
    {
      path: '/astronomical',
      component: astronomical
    },
    {
      path: '/blood-sugar',
      component: bloodsugar
    },
    {
      path: '/capacitance',
      component: capacitance
    },
    {
      path: '/computer',
      component: computer
    },
    {
      path: '/cooking',
      component: cooking
    },
    {
      path: '/data-transfer',
      component: datatransfer
    },
    {
      path: '/density',
      component: density
    },
    {
      path: '/dynamic-viscosity',
      component: dynamicviscosity
    },
    {
      path: '/electric-charge',
      component: electriccharge
    },
    {
      path: '/electrical-resistance',
      component: electricalresistance
    },
    {
      path: '/energy',
      component: energy
    },
    {
      path: '/force',
      component: force
    },
    {
      path: '/illuminance',
      component: illuminance
    },
    {
      path: '/inductance',
      component: inductance
    },
    {
      path: '/length',
      component: length
    },
    {
      path: '/temperature',
      component: temperature
    },
    {
      path: '/volume',
      component: volume
    },
    {
      path: '/weight',
      component: weight
    },
    {
      path: '/time',
      component: time
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js